import zipy from 'zipyai';

interface EventProperties {
  [key: string]: string;
}

interface ErrorLogParams {
  errorType: string;
  message: string;
  category?: string;
  errInfo?: object;
}

/**
 * https://docs.zipy.ai/product-features/custom-logs
 */

/**
 * Capture custom messages
 * @param message - The message to log.
 * @param info - Optional additional information to include.
 */
export function logCustomMessage({
  message,
  info,
}: {
  message: string;
  info: object;
  module?: string;
}) {
  zipy.logMessage(message, {
    message: 'CUSTOM_MESSAGE',
    info,
    module,
  });
}

/**
 * Logs a custom exception to Zipy.
 * @param error - The error object to log.
 * @param additionalInfo - Optional additional context about the error.
 */
export function logCustomException({
  message,
  error,
}: {
  message: string;
  error?: Error;
}) {
  zipy.logException({
    message,
    error,
  });
}

/**
 * Log your custom application errors
 */
export function logCustomError({
  errorType,
  message,
  category,
  errInfo,
}: ErrorLogParams) {
  zipy.logError(errorType, message, category, errInfo);
}

/**
 * Logs a custom event to Zipy.
 * @param eventName - The name of the event.
 * @param properties - Optional properties associated with the event.
 */
export function logCustomEvent(eventName: string, properties: EventProperties) {
  zipy.logEvent(eventName, properties);
}
